import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const partners = [
  { name: 'Crestron', logo: 'https://logo.clearbit.com/crestron.com' },
  { name: 'Sonetinx', logo: 'https://logo.clearbit.com/sonitex.com' },
  { name: 'Panasonic', logo: 'https://logo.clearbit.com/panasonic.com' },
  { name: 'Sony', logo: 'https://logo.clearbit.com/sony.com' },
  { name: 'Mobotix', logo: 'https://logo.clearbit.com/mobotix.com' },
  { name: 'Paradigm', logo: 'https://logo.clearbit.com/paradigm.com' },
  { name: 'Wharfedale', logo: 'https://logo.clearbit.com/wharfedale.co.uk' },
  { name: 'Tannoy', logo: 'https://logo.clearbit.com/tannoy.com' },
  { name: 'BenQ', logo: 'https://logo.clearbit.com/benq.com' },
  { name: 'Siemens', logo: 'https://logo.clearbit.com/siemens.com' },
  { name: 'Apollo', logo: 'https://logo.clearbit.com/apollo-fire.co.uk' },
  { name: 'Dahua', logo: 'https://logo.clearbit.com/dahuasecurity.com' },
  { name: 'Hikvision', logo: 'https://logo.clearbit.com/hikvision.com' },
  { name: 'CP Plus', logo: 'https://logo.clearbit.com/cpplusworld.com' },
  { name: 'Commax', logo: 'https://logo.clearbit.com/commax.com' },
  { name: 'DSC', logo: 'https://logo.clearbit.com/dsc.com' },
  { name: 'JBL', logo: 'https://logo.clearbit.com/jbl.com' },
  { name: 'Honeywell', logo: 'https://logo.clearbit.com/honeywell.com' },
  { name: 'Klipsch', logo: 'https://logo.clearbit.com/klipsch.com' }
];

const TechnologyPartners = () => {
  const [sectionRef, sectionVisible] = useScrollAnimation(0.2);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-900 to-black">
      <div
        ref={sectionRef}
        className={`max-w-6xl mx-auto px-6 scroll-fade-in ${sectionVisible ? 'visible' : ''}`}
      >
        <div className="text-center">
          <p className="text-[11px] uppercase tracking-[0.3em] text-blue-400">
            Ecosystem
          </p>
          <h2 className="mt-3 text-3xl md:text-4xl font-semibold text-white">
            Trusted Technology Partners
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-gray-400 leading-relaxed">
            Brands and platforms we work with across automation, AV, surveillance, and critical infrastructure systems.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-10 gap-y-8 md:gap-x-14 md:gap-y-10">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="group flex h-10 w-[110px] items-center justify-center md:h-12 md:w-[126px]"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                loading="lazy"
                className="max-h-full max-w-full object-contain grayscale opacity-50 transition-all duration-300 group-hover:scale-105 group-hover:grayscale-0 group-hover:opacity-100"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  const fallback = e.currentTarget.nextElementSibling;
                  if (fallback) {
                    fallback.classList.remove('hidden');
                  }
                }}
              />
              <span className="hidden text-[10px] font-semibold uppercase tracking-[0.18em] text-white/60 text-center">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyPartners;
